import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_TOKEN_KEY = 'pb_admin_token_v1';

export function getAdminToken() {
    try {
        return localStorage.getItem(ADMIN_TOKEN_KEY) || null;
    } catch {
        return null;
    }
}

export function setAdminToken(token) {
    try {
        if (token) localStorage.setItem(ADMIN_TOKEN_KEY, token);
        else localStorage.removeItem(ADMIN_TOKEN_KEY);
    } catch {
        /* ignore */
    }
}

export const api = axios.create({
    baseURL: API,
    headers: { 'Content-Type': 'application/json' },
});

// Inject admin Authorization header on every request if we have a token.
api.interceptors.request.use((config) => {
    const t = getAdminToken();
    if (t) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

export async function listSamples(contentType) {
    const params = {};
    if (contentType && contentType !== 'All') params.contentType = contentType;
    const { data } = await api.get('/samples', { params });
    return data;
}

export async function createSample(payload) {
    const { data } = await api.post('/samples', payload);
    return data;
}

export async function deleteSample(id) {
    const { data } = await api.delete(`/samples/${id}`);
    return data;
}

export async function submitContact(payload) {
    const { data } = await api.post('/contact', payload);
    return data;
}

export async function adminLogin(password) {
    const { data } = await api.post('/admin/login', { password });
    return data; // { ok, token }
}

export async function adminVerify() {
    const { data } = await api.get('/admin/verify');
    return data;
}

export async function adminLogout() {
    try {
        await api.post('/admin/logout');
    } catch {
        /* ignore — token is cleared client-side anyway */
    }
    setAdminToken(null);
}

export const CONTENT_TYPES = [
    'Blog',
    'Newsletter',
    'Press Release',
    'Website Copy',
    'Landing Page',
    'UI Microcopy',
    'Bilingual',
];

export const LANGUAGES = ['English', 'Bengali', 'Both'];

export const PROJECT_TYPES = [
    'Blog',
    'Newsletter',
    'Press Release',
    'Website Copy',
    'Landing Page',
    'UI Microcopy',
    'Bilingual / Bengali',
    'Brand Strategy',
    'Other',
];
